const staff_evaluations = {
  permissionSource: 'api::staff-evaluation.staff-evaluation',
  creationTitle: 'Staff Evaluations Report',
  creationEndPoint: '/staff-evaluations',
  detailTitle: 'Staff Evaluations: :code',
  detailEndPoint: '/staff-evaluations/:id?populate=*',
  detail: [
    {
      label: 'Title',
      value: 'title',
      tag: 'input',
      type: 'text',
      placeholder: 'Staff Evaluations Title',
      required: true,
    },
    {
      label: 'Score',
      value: 'score',
      tag: 'input',
      type: 'number',
      placeholder: 'Staff Evaluations Title',
      required: true,
    },
    {
      label: ' Tag',
      value: 'tag',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Content',
      value: 'content',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Type',
      value: 'type',
      tag: 'single-enum-select',
      dataSourceUrl: '/content-type-builder/content-types/api::staff-evaluation.staff-evaluation',
      dataLabel: 'type',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default staff_evaluations
